





































import Vue from 'vue';
import Component from 'vue-class-component';
import { Global } from '@/store';
import { Prop, Watch } from 'vue-property-decorator';

@Component({})
class DatePicker extends Vue {
  @Global.State('lang') lang;

  @Prop() date;
  @Prop() disabled;
  @Prop() max;
  // Off by default, so the report toolbars this was built for keep their message row.
  // Opt in where the picker sits in a compact card and the empty row leaves a gap.
  @Prop() hideDetails;
  // Defaults to 'Pick date' when not passed. Pass '' where a surrounding heading already
  // names the field, so the floating label doesn't repeat it.
  @Prop() label;

  isDatePickerOpen = false;
  selected_date = '';
  computedDate = '';

  mounted() {
    const regDate = this.date;
    this.computedDate =
      regDate.substring(8, 10) +
      '-' +
      regDate.substring(5, 7) +
      '-' +
      regDate.substring(0, 4);
    this.selected_date = this.date;
  }

  @Watch('date')
  updateSelectedDate() {
    this.selected_date = this.date;
    const regDate = this.date;
    this.computedDate =
      regDate.substring(8, 10) +
      '-' +
      regDate.substring(5, 7) +
      '-' +
      regDate.substring(0, 4);
  }

  onDateChanged() {
    this.isDatePickerOpen = false;
    this.$emit('dateChanged', this.selected_date);
  }
}

export default DatePicker;
